import { useState } from "react"
import { useInView } from "react-intersection-observer"
import { useShallow } from "zustand/react/shallow"
import { schemaOptionsFilter } from "../../../utils"

// components
import { Flex } from "antd"
import DynamicField from "../../../../../../../../../../components/form-fields/DynamicField/DynamicField"
import ArmActions from "../../../components/ArmActions/ArmActions"
import { PrimeButton, TextInput } from "components-design-system"
import SubjectJoinReason from "./SubjectJoinReason"
import CellValidation from "../../../components/CellValidation/CellValidation"
import ProductCard from "../ProductCard/ProductCard"
import CharCounter from "components/CharCounter/CharCounter"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

const Arm = ({
  schema,
  arm,
  arms,
  rowIndex,
  colIndex,
  fieldKey,
  handleLeft,
  handleRight,
  handleDelete,
  handleChange,
  onDeleteProduct = {},
  onOpenProduct = {},
  onAddReason = {},
  onChangeReason = {},
  onDeleteReason = {},
  type = "period",
  periodIndex,
}) => {
  const { ref: visibleRef, inView: inViewport } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  })
  const [showActions, setShowActions] = useState(false)

  const { formView, readOnly } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      formView: state.formView,
    }))
  )

  let isManualOverride = fieldKey === "title" || fieldKey === "description"

  const renderFields = () => {
    if (fieldKey === "products") {
      let products = arm?.products || []
      return (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {products.map((product, i) => {
              return (
                <ProductCard
                  key={`${arm.id}-product-${i}`}
                  index={i}
                  arm={arm}
                  product={product}
                  readOnly={readOnly}
                  showActions={showActions}
                  onOpenProduct={onOpenProduct}
                  onDeleteProduct={onDeleteProduct}
                />
              )
            })}
          </div>
          {readOnly !== true && (
            <PrimeButton
              size="small"
              type="add"
              style={{
                marginTop: 16,
              }}
              onClick={() => onOpenProduct({ arm })}
            >
              Add Product
            </PrimeButton>
          )}
        </>
      )
    } else if (fieldKey === "joined_reason_details") {
      let reasons = arm?.joined_reason_details || []

      return (
        <>
          <div>
            {reasons.map((reason, reasonIndex) => {
              return (
                <SubjectJoinReason
                  key={arm.id + colIndex + rowIndex + reasonIndex}
                  arm={arm}
                  reason={reason}
                  onChangeReason={(key, val) => onChangeReason(key, val, colIndex, reasonIndex)}
                  onDeleteReason={() => onDeleteReason(colIndex, reasonIndex)}
                />
              )
            })}
          </div>
          {readOnly !== true && (
            <PrimeButton
              size="small"
              type="add"
              style={{
                marginTop: 16,
              }}
              onClick={() => onAddReason({ arm, armIndex: colIndex })}
            >
              Add Reason
            </PrimeButton>
          )}
        </>
      )
    } else if (isManualOverride) {
      return (
        <DynamicField
          type={schema.type}
          fieldProps={{
            disabled: true,
            readOnly: readOnly,
            value: arm?.[fieldKey],
            onChange: (val) => handleChange(val, arm, fieldKey),
          }}
        />
      )
    } else {
      return (
        <Flex
          vertical
          gap={6}
        >
          <DynamicField
            type={schema.type}
            fieldProps={{
              readOnly,
              options: schemaOptionsFilter(schema.items, formView?.id),
              value: arm?.[fieldKey],
              onChange: (val) => handleChange(val, arm, fieldKey),
            }}
          />

          {fieldKey === "type" && (arm.type === "Other" || arm.type === "Sham Comparator") && (
            <div>
              <TextInput
                placeholder={"Enter type"}
                readOnly={readOnly}
                value={arm.other_type}
                onChange={(e) => handleChange(e.target.value, arm, "other_type")}
              />
              {formView.id === "eudra" && (
                <div className="char-counter-container">
                  <CharCounter
                    value={arm.other_type}
                    maxChars={50}
                  />
                </div>
              )}
            </div>
          )}
        </Flex>
      )
    }
  }
  if (arm === null) {
    return <td />
  }

  return (
    <td
      ref={visibleRef}
      className="text-left"
      onMouseEnter={() => setShowActions(true)}
      onMouseLeave={() => setShowActions(false)}
    >
      {inViewport ? <>{renderFields()}</> : <div style={{ padding: 10 }} />}

      <ArmActions
        arms={arms}
        arm={arm}
        colIndex={colIndex}
        showActions={showActions}
        handleLeft={rowIndex === 0 ? () => handleLeft(colIndex) : null}
        handleRight={rowIndex === 0 ? () => handleRight(colIndex) : null}
        canDelete={rowIndex === 0 ? true : false}
        handleDeleteArm={handleDelete}
        jpath={`pf-arm-${type}-${arm.id}-${fieldKey}`}
        source={"participant-flow"}
        manualOverride={isManualOverride}
        periodIndex={periodIndex}
        value={arm?.[fieldKey]}
        schema={schema}
        setShowActions={setShowActions}
      />
      <CellValidation
        table="participants"
        errorKey={`results_participant_flow_participant_flow_table_global_arms_${colIndex + 1}_${fieldKey}`}
      />
    </td>
  )
}

export default Arm
